var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.193,
    height: 14.806,
    viewBox: "0 0 20.193 14.806",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fafafa;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19367",
    "data-name": "Group 19367",
    transform: "translate(-91.904 -818.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19078",
    "data-name": "Group 19078",
    transform: "translate(100.27 818.346) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7501",
    "data-name": "Path 7501",
    className: "cls-1",
    d: "M7.4,8.365a.949.949,0,0,1-.673-.288L.288,1.635a.93.93,0,0,1,0-1.346.929.929,0,0,1,1.346,0L8.077,6.731a.93.93,0,0,1,0,1.346A.949.949,0,0,1,7.4,8.365Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19079",
    "data-name": "Group 19079",
    transform: "translate(100.27 824.787) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7502",
    "data-name": "Path 7502",
    className: "cls-1",
    d: "M.961,8.365a.949.949,0,0,1-.673-.288.93.93,0,0,1,0-1.346L6.73.288a.929.929,0,0,1,1.346,0,.93.93,0,0,1,0,1.346L1.635,8.077A.949.949,0,0,1,.961,8.365Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19080",
    "data-name": "Group 19080",
    transform: "translate(112.097 824.787) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7503",
    "data-name": "Path 7503",
    className: "cls-1",
    d: "M.961,20.192A.964.964,0,0,1,0,19.231V.962a.961.961,0,1,1,1.923,0V19.231A.964.964,0,0,1,.961,20.192Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.ea0ff4b5500d150ab6eb1a238bd9630f.svg";
export { ForwardRef as ReactComponent };